import { useCallback, useEffect } from 'react';

// local imports
import { CustomerService } from 'app/services';
import useDataApi from '../../use-data-api';
import { FormatUtils, TableUtils } from 'app/utils';
import { mapActivationStatus } from 'app/utils/mapper';
import { CustomBadge } from 'app/components/atoms';

const useCustomerAgreementsService = queries => {
  const [service, setService] = useDataApi();

  const fetchData = useCallback(async () => {
    const customerAgreements = await CustomerService.getCustomerAgreementsList(queries);
    const customerAgreementsData = customerAgreements.data.data;

    const out = customerAgreementsData?.map(item => {
      const { name_tr, name_en, status, created_at, consent_date, ...rest } = item;

      const customStatus = mapActivationStatus(status.id);
      const agreementName = `${name_tr} (${name_en})`;

      return {
        ...rest,
        name: agreementName,
        created_at: FormatUtils.convertDateString(created_at),
        consent_date: FormatUtils.convertDateString(consent_date)
      };
    });

    return {
      table: {
        columns: TableUtils.customerAgreementsList,
        rows: out
      },
      totalCount: customerAgreements?.data?.total_count,
      total: Math.round(customerAgreements?.data?.total_count / parseInt(queries.limit))
    };
  }, [queries]);

  useEffect(() => setService(() => fetchData()), [setService, fetchData]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default useCustomerAgreementsService;
